import { ILoanCalcEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/ILoanCalcEndorsementConfig';
import React from 'react';
import { Card, Grid } from 'ui-toolkit/components';
import { LabelValueViewer } from '../shared/LabelValueViewer';
import { TransactionTypesViewer } from '../shared/TransactionTypesViewer';
import { eEndorsementNames, TemplateEndorsementsViewer } from './TemplateEndorsementsViewer';
import { humanizeEndorsement } from 'utilities/shared/stringMethods/humanizeEndorsement';

interface ILoanCalcEndorsementsViewerProps {
  loanCalcEndorsements: ILoanCalcEndorsementConfigData[];
}

export const LoanCalcEndorsementsViewer: React.FC<ILoanCalcEndorsementsViewerProps> = ({ loanCalcEndorsements }) => (
  <TemplateEndorsementsViewer endorsements={loanCalcEndorsements} endorsementName={eEndorsementNames.LoanCalc}>
    {loanCalcEndorsements.map((endorsement, index) => (
      <Card key={endorsement.endorsementType} title={index + 1} isCollapsible>
        <Grid columnCount={3}>
          <LabelValueViewer
            label={'Endorsement'}
            value={humanizeEndorsement(endorsement.endorsementType)}
            templateColumns={'1fr 1fr'}
          />
          <LabelValueViewer label={'Percent of Loan'} value={endorsement.percentOfLoan} templateColumns={'1fr 1fr'} />
          <LabelValueViewer label={'Minimum '} value={endorsement.minimum} templateColumns={'1fr 1fr'} />
        </Grid>
        <TransactionTypesViewer transactionTypes={endorsement.transactionTypes} />
      </Card>
    ))}
  </TemplateEndorsementsViewer>
);
